import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import StoreContext from "./../../../Store/Context";
import { SEARCH_ICON } from "./../../Constants/SrcImages";
import { Row, Col, Label, Container } from "reactstrap";
import { PAYMENT_ACCOUNT } from "./../../Constants/Util";
import DatatableExpand from "../../Constants/DatatableExpand";
import { getMontoDates, getGrades, getRegistration, getcxcByPerson, getcxcDetailByCxc_id } from "../../Constants/Services";
import { COLUMNS_GRADES, EXPAND_ROW_GRADE_ACTIVATION_ECUENTA } from "../../Constants/DatatableColumns";
import { IGrades, IGradeSelected, IMontoDate, IFormMatricula, IRegistration } from "./../../Constants/Interfaces";
import moment from "moment";

interface ICxcType {
  cxc_id: string;
  cxc_mes: string;
  cxc_stado: string;
  cxc_moro: string;
  cxc_saldo: string;
  cxc_morostado: string;
}

interface ICxcDetail {
  cxcd_id: string;
  cxcd_type_desc: string;
  cxcd_monto: string;
  cxcs_desc: string;
}

interface ICuentasState {
  dataRegistration: IRegistration[];
  dataMontoDate: IMontoDate[];
  formMatricula: IFormMatricula;
  dataCxcDetail: ICxcDetail[];
  dataGrades: IGrades[];
  dataCxcType: ICxcType[];
  dataPersonSelected: {
    per_id: string;
    per_name: string;
  };
  ap_desc: string;
  dataGradeSelected: IGradeSelected;
  isOpenECuentas: boolean;
  loading: boolean;
}

class ECuentas extends Component<RouteComponentProps<{}>, ICuentasState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dataRegistration: [],
      dataCxcDetail: [],
      dataMontoDate: [],
      dataCxcType: [],
      ap_desc: "",
      formMatricula: {
        cxcr_id: "",
        cxcr_registration: "",
        cxcr_tcuenta: "",
        cxcr_matricula: "",
        cxcr_mensualidad: "",
        cxcr_stado: "",
        cxcr_saldo: "",
        cxcr_status: "",
        cxcr_date: "",
        cxcr_anualidad: "",
        cxcr_s_anualidad: "",
        cxcr_saldo_cole: "",
        cxcr_anualidad_state: "",
      },
      dataPersonSelected: {
        per_id: "",
        per_name: "",
      },
      isOpenECuentas: false,
      loading: false,
      dataGrades: [],
      dataGradeSelected: {
        gr_id: "",
        gr_desc: "",
      },
    };

    this.fetchMontoDates = this.fetchMontoDates.bind(this);
    this.fetchGrade = this.fetchGrade.bind(this);
    this.fetchRegistration = this.fetchRegistration.bind(this);
    this.handlerGetECuenta = this.handlerGetECuenta.bind(this);
    this.handlerSetPerson = this.handlerSetPerson.bind(this);
    this.goBack = this.goBack.bind(this);
    this.fetchCxcByPerson = this.fetchCxcByPerson.bind(this);
    this.fetchType = this.fetchType.bind(this);
  }

  async fetchType({ cxc_id }) {
    const response = await getcxcDetailByCxc_id(cxc_id);
    this.setState({
      dataCxcDetail: response,
    });
  }

  async fetchGrade() {
    const response = await getGrades();
    this.setState({
      dataGrades: response,
    });
  }

  async fetchRegistration({ gr_id, gr_desc }: IGradeSelected) {
    const response = await getRegistration(gr_id);
    this.setState({
      dataRegistration: response,
      dataGradeSelected: { gr_id, gr_desc },
    });
  }

  async fetchCxcByPerson({ per_id }) {
    const response = await getcxcByPerson(per_id);
    var ap_desc;
    if (response.apayment[0] !== undefined) {
      ap_desc = response.apayment[0].ap_desc;
    }
    // if (response.cxcr_cxcregistration[0] !== undefined && response.cxc_cxcobrar.length > 0) {
      this.setState({
        dataMontoDate: response,
        loading: false,
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_matricula: response.cxcr_cxcregistration[0] !== undefined ? response.cxcr_cxcregistration[0].cxcr_matricula : "0",
          cxcr_saldo: response.cxcr_cxcregistration[0] !== undefined ? response.cxcr_cxcregistration[0].cxcr_saldo : "0",
          cxcr_anualidad: response.cxcr_cxcregistration[0] !== undefined ? response.cxcr_cxcregistration[0].cxcr_anualidad  : "0",
          cxcr_anualidad_state: response.cxcr_cxcregistration[0] !== undefined ? response.cxcr_cxcregistration[0].cxcr_anualidad_state:"0",
          cxcr_saldo_cole: response.cxcr_cxcregistration[0] !== undefined ? response.cxcr_cxcregistration[0].cxcr_saldo_cole :"0",
          cxcr_stado: response.cxcr_cxcregistration[0] !== undefined ?  response.cxcr_cxcregistration[0].cxcr_stado :"0",
        },
        dataCxcType: response.cxc_cxcobrar,
        ap_desc: response.apayment[0] !== undefined? ap_desc:"",
      });
    // }
  }

  async fetchMontoDates({ per_id }) {
    const response = await getMontoDates(per_id);
    if (response.length > 0) {
      const result = response.find(function (item) {
        if (moment(item.mtd_date).format("YYYY-MM-DD") >= moment(new Date()).format("YYYY-MM-DD")) return item.mtd_date;
        return false;
      });
      if (result === undefined) {
        result.mtd_date = moment(new Date()).format("YYYY-MM-DD");
      }
      this.setState({
        dataMontoDate: response,
        loading: false,
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_date: result.mtd_date,
        },
      });
    }
  }

  componentDidMount() {
    this.fetchGrade();
  }

  handlerSetPerson(row: any) {
    this.setState({
      dataPersonSelected: {
        per_id: row.per_id,
        per_name: row.per_name,
      },
      isOpenECuentas: true,
      dataCxcType:[],
      dataMontoDate:[]
    });
    this.fetchMontoDates({ per_id: row.per_id });
    this.fetchCxcByPerson({ per_id: row.per_id });
  }

    goBack() {
    this.setState({
      isOpenECuentas: false,
      formMatricula: {
        cxcr_id: "",
        cxcr_registration: "",
        cxcr_tcuenta: "",
        cxcr_matricula: "",
        cxcr_mensualidad: "",
        cxcr_stado: "",
        cxcr_saldo: "",
        cxcr_status: "",
        cxcr_date: "",
        cxcr_anualidad: "",
        cxcr_s_anualidad: "",
        cxcr_saldo_cole: "",
        cxcr_anualidad_state: "",
      },
    });
  }

  handlerGetECuenta = (cell: string, row: any) => {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handlerSetPerson(row)}>
            {row.per_cedula}
          </Label>
          <img className="img-status img-search" onClick={() => this.handlerSetPerson(row)} src={SEARCH_ICON} alt="" />
        </Col>
      </Row>
    );
  };

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Container className="mt-4">
          <Row>
            <Col sm={12} className="text-center">
              <Label className="font-weight-bold">
                <h4>Estado de cuentas</h4>
              </Label>
            </Col>
            <Col sm={12}>
              {props.isOpenECuentas ? (
                <PAYMENT_ACCOUNT props={props} goBack={this.goBack} fetchType={this.fetchType} dataCxc={props.dataCxcDetail} />
              ) : (
                <DatatableExpand
                  data={props.dataGrades}
                  columns={COLUMNS_GRADES()}
                  keyProp="gr_id"
                  expandRow={EXPAND_ROW_GRADE_ACTIVATION_ECUENTA(this.fetchRegistration, props.dataRegistration, this.handlerGetECuenta)}
                  exportD={false}
                  searchs={false}
                />
              )}
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default ECuentas;
